import React from 'react';
import cn from 'classnames';
import styles from './Typography.module.scss';

export const LoginHeaderText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.loginHeader)}>{children}</span>;

export const BodySecondaryMediumText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.bodySecondary)}>{children}</span>;

export const BodyMediumText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.bodyPrimary)}>{children}</span>;

export const TitleText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.title)}>{children}</span>;

export const SmallUppercaseText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.smallUppercase)}>{children}</span>;

export const ExtraSmallUppercaseText = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn(className, styles.extraSmallUppercase)}>{children}</span>;
